import { Typography, message } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Loading } from "../../../components/Loading";
import Api from "../../../services/api";
import MetricsCards from "./metricsCards";
import FormList from "./formList";
import { Container, ContentPanel } from "./styles";

const { Text } = Typography;

const Reports = ({
  dateRange,
  locationId,
  topicId,
  includeChildren,
  reportToHistory,
  userId,
  createdBy,
  status,
  searchText,
  formId,
  user,
  onFormClick,
  orderField = 'AnswerCount'
}) => {
  const { t } = useTranslation();

  // Estados dos dados
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [metrics, setMetrics] = useState({
    totalAnswers: 0,
    uniqueForms: 0,
    avgAnswersPerForm: 0,
    topForm: null
  });
  const [formsData, setFormsData] = useState([]);
  const [currentOrderField, setCurrentOrderField] = useState(orderField);

  // Função para buscar dados
  const fetchReportsData = useCallback(async () => {
    setLoading(true);
    setInitialLoading(false);

    try {
      // Se não há filtro de data, enviar null (não aplicar range padrão)
      let startDate = dateRange?.[0]?.format('YYYY-MM-DD') || null;
      let endDate = dateRange?.[1]?.format('YYYY-MM-DD') || null;
      
      const request = {
        startDate: startDate,
        endDate: endDate,
        locationId: locationId,
        locationIncludeChildren: includeChildren,
        topicId: topicId,
        userId: userId,
        createdBy: createdBy,
        status: status,
        searchText: searchText,
        formId: formId,
        orderField: currentOrderField,
        ascendingOrder: currentOrderField === 'FormName' ? true : false, // Alfabética crescente, outros descendentes
        isAdmin: user?.profiles?.some(p => p.role.name === "Administrator") || false,
        ShowOnlyMyTasks: reportToHistory === 1 || user?.showOnlyMyTasks || false, // 1 = Minhas tarefas, 2 = Tarefas da localização
        ReportToHistory: reportToHistory || 1, // 1 = Minhas tarefas, 2 = Tarefas da localização, 3 = Tarefas de relatório
      };

      const { data } = await Api.post('DashboardCustomFlowy/getFormsAnswersSummary', request);

      if (data.response) {
        setMetrics({
          totalAnswers: data.response.totalAnswers || 0,
          uniqueForms: data.response.uniqueForms || 0,
          avgAnswersPerForm: data.response.avgAnswersPerForm || 0,
          topForm: data.response.topForm || null
        });
        setFormsData(data.response.formsSummary || []);
      } else {
        message.error(t('Reports.ErrorFetchingData', 'Erro ao buscar dados do relatório.'));
      }
    } catch (error) {
      message.error(t('Reports.ErrorFetchingData', 'Erro ao buscar dados do relatório.'));
    } finally {
      setLoading(false);
    }
  }, [dateRange, locationId, topicId, includeChildren, user, t, reportToHistory, userId, createdBy, status, searchText, formId, currentOrderField]);

  useEffect(() => {
    fetchReportsData();
  }, [fetchReportsData]);

  // Função para lidar com mudança de ordenação
  const handleOrderingChange = (newOrderField) => {
    setCurrentOrderField(newOrderField);
  };

  return (
    <Container>
      <ContentPanel>



        {/* Loading inicial */}
        {initialLoading ? (
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <Loading />
            <Text type="secondary" style={{ marginTop: 16, display: 'block' }}>
              {t('Reports.LoadingData')}
            </Text>
          </div>
        ) : (
          <>
            {/* Cards de Métricas */}
            <MetricsCards metrics={metrics} loading={loading} />

            {/* Lista de Formulários */}
            <FormList
              formsData={formsData}
              totalAnswers={metrics.totalAnswers}
              dateRange={dateRange}
              loading={loading}
              locationId={locationId}
              topicId={topicId}
              includeChildren={includeChildren}
              user={user}
              onFormClick={onFormClick}
              onOrderingChange={handleOrderingChange}
            />
          </>
        )}
      </ContentPanel>
    </Container>
  );
};

export default Reports;